import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import "../Styles/_DataConflictWindow.css";

class DataConflictWindow extends Component {
    handleNoClick() {
        this.props.handleClose();
    }

    handleYesClick() {
        this.props.handleSubmit();
    }

    handleEnter() {}

    SetBodyScroll() {
        let el = document.getElementById("body");

        if (el.style.overflow === "hidden") {
            el.style.overflow = "initial";
        }
    }

    render() {
        return (
            <Dialog
                className="data-conflict-dialog"
                classes={{ paper: "data-conflict-dialog-paper" }}
                disableBackdropClick
                disableEscapeKeyDown
                aria-labelledby="simple-dialog-title"
                open={this.props.open || false}
                onEnter={this.handleEnter.bind(this)}
            >
                <div className="layout vertical data-conflict-window">
                    <div className="data-conflict-window-inner">
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <p className="title">{this.props.heading}</p>
                                </div>
                            </div>
                        </div>

                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <div className="sub-title">{this.props.subheading}</div>
                                </div>
                            </div>
                        </div>
                        <div className="box">
                            <div className="row">
                                {this.props.noText && (
                                    <div className="column">
                                        <button className="custom-button" onClick={this.handleNoClick.bind(this)}>
                                            <div className="layout vertical center-center inbutton-text">{this.props.noText}</div>
                                        </button>
                                    </div>
                                )}
                                {this.props.yesText && (
                                    <div className="column">
                                        <button
                                            className={`custom-button ${this.props.loading ? "loading" : ""}`}
                                            style={{ float: "right" }}
                                            onClick={this.props.loading ? null : this.handleYesClick.bind(this)}
                                        >
                                            <div className="layout vertical center-center inbutton-text">{this.props.yesText}</div>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default withRouter(DataConflictWindow);



// WEBPACK FOOTER //
// ./src/views/Order/components/_DataConflictWindow.jsx